// extracted by mini-css-extract-plugin
export default {"wrap":"Loader2_wrap__3IeMF","ball":"Loader2_ball__TaPCq","bounce":"Loader2_bounce__uCGuT"};